$(function() {
    new Swiper('.swiper-container', {
        loop: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 90,
        breakpoints: {
            1024: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 0
            }
        },
        on: {
            init: function () {
                // Add css class if the slider has only one slide
                if (this.slides.length < 2) {
                    $(this.$el).addClass('swiper-container--one-slide');
                }
                // Use autoplay duration value from HTML
                this.params.autoplay.delay = $(this.$el).data('delay');
                this.updateSlides();
            },
            slideChange: function () {
                // Fix pagination on autoplay
                this.pagination.render();
                this.pagination.update();
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });
});